import { render, staticRenderFns } from "./CpttList.vue?vue&type=template&id=73bf5b94&scoped=true&"
import script from "./CpttList.vue?vue&type=script&lang=js&"
export * from "./CpttList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73bf5b94",
  null
  
)

export default component.exports